const  UnsecureFastHash = (data: any, type:string, label: any) => {
  const buttonObject = JSON.stringify(data);
  const labelValue = label ? label.toString().replace(/[^a-zA-Z0-9]+/g, '-').replace(/^-|-$/g, '') : '';
  const generatedId = buttonObject.split('').reduce((hash, c) =>(hash << 5) - hash + c.charCodeAt(0),0).toString().slice(-4);;
   const prefix= type === 'button' ? 'btn-' : 'lnk-';
   return labelValue.length > 0 ? `${labelValue}-${prefix}${generatedId}` : `${prefix}${generatedId}`;
};

export const useUniqueId = (Props: any, componentName: string, label: any) => {
  if (Props.id){
    return Props.id
  }
  const hocComponent = Props.additionalAnalyticsData?.componentName ? (Props?.additionalAnalyticsData?.componentName).replace(/[^a-zA-Z0-9]/g, '-') : '';
  const uniqueId = UnsecureFastHash(Props, componentName, label);
  return hocComponent.length > 0?`${hocComponent}-${uniqueId}`: uniqueId;
};